import FilterablePeopleTableColumnSelectorModal from './FilterablePeopleTableColumnSelectorModal';

export { useFilterableTableColumnSelectorModal } from './hooks';

export default FilterablePeopleTableColumnSelectorModal;
